/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateOrgRequest
 */
export interface CreateOrgRequest {
    /**
     * The organization label.
     * @type {string}
     * @memberof CreateOrgRequest
     */
    label: string;
}

/**
 * Check if a given object implements the CreateOrgRequest interface.
 */
export function instanceOfCreateOrgRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function CreateOrgRequestFromJSON(json: any): CreateOrgRequest {
    return CreateOrgRequestFromJSONTyped(json, false);
}

export function CreateOrgRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateOrgRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function CreateOrgRequestToJSON(value?: CreateOrgRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
    };
}

